// extracted by mini-css-extract-plugin
module.exports = {"content":"_25d45facb5--content--UKOFS","footer-container":"_25d45facb5--footer-container--ZJrh5"};